// note_json keys that the backend computes, not note sections: AI/billing
// metadata and the EHR vitals pull. The Edit screens do not show them as
// editable cards (Level of Visit is shown as a read-only chip instead), and
// they are never sent back through /v1/recording/category/update, which
// merges whatever it receives into note_json.
export const READ_ONLY_NOTE_KEYS = [
  "level_of_visit",
  "level_of_visit_reasoning",
  "visit_class",
  "wellness_sequence",
  "careiq_alerts",
  "suggested_icd10",
  "suggested_orders",
  "applied_instructions",
  "vitals",
];

export function omitReadOnlyNoteKeys(contextDict) {
  const result = {};
  for (const [key, value] of Object.entries(contextDict || {})) {
    if (!READ_ONLY_NOTE_KEYS.includes(key)) {
      result[key] = value;
    }
  }
  return result;
}

// level_of_visit is stored as an int 1-5. Same normalisation as care's
// LiveScribePanel: accept "4", "Level 4" or an E/M code; 0 = none.
export function normalizeLov(raw) {
  const n = parseInt(String(raw ?? "").replace(/[^0-9]/g, ""), 10);
  if (!n) return 0;
  if (n >= 99211 && n <= 99215) return n - 99210;
  if (n >= 99202 && n <= 99205) return n - 99200;
  return n >= 1 && n <= 5 ? n : 0;
}
